// ../../node_modules/.pnpm/@radix-ui+react-use-callback-ref@1.1.2_@types+react@19.2.14_react@19.2.5/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
import * as React from "react";
function useCallbackRef(callback) {
  const callbackRef = React.useRef(callback);
  React.useEffect(() => {
    callbackRef.current = callback;
  });
  return React.useMemo(() => (...args) => callbackRef.current?.(...args), []);
}

export {
  useCallbackRef
};
//# sourceMappingURL=chunk-BQ72SK4G.mjs.map